'use client';

import { useEffect } from 'react';

const BRAZE_SDK_URL = 'https://js.appboycdn.com/web-sdk/5.8/braze.min.js';

type IdleWindow = Window & {
  requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
  cancelIdleCallback?: (id: number) => void;
};

function injectScript(src: string) {
  if (document.head.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

// Loads the Braze and Permutive bundles after first paint. Their stubs in <head> queue
// calls and replay them once the SDK arrives, so nothing is lost by loading them late.
export default function DeferredVendorScripts() {
  useEffect(() => {
    let timeoutId: number | null = null;
    let idleId: number | null = null;
    const w = window as IdleWindow;

    const run = () => {
      injectScript(BRAZE_SDK_URL);

      const organizationId = process.env.NEXT_PUBLIC_PERMUTIVE_ORGANIZATION_ID;
      const workspaceId = process.env.NEXT_PUBLIC_PERMUTIVE_WORKSPACE_ID;
      if (organizationId && workspaceId) {
        injectScript(
          `https://${organizationId}.edge.permutive.app/${workspaceId}-web.js`
        );
      }
    };

    if (w.requestIdleCallback) {
      idleId = w.requestIdleCallback(run, { timeout: 3000 });
    } else {
      timeoutId = window.setTimeout(run, 2000);
    }

    return () => {
      if (idleId !== null && w.cancelIdleCallback) {
        w.cancelIdleCallback(idleId);
      }
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return null;
}
